import { CommandType } from "~app/common/services/cqs/CommandType";
import { ArbetsorderHandelssortimentBaseCommand } from "./ArbetsorderHandelssortimentBaseCommand";
export class SetArbetsorderHandelssortimentAngivenKvantitetCommand extends ArbetsorderHandelssortimentBaseCommand {
    kvantitet?: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetArbetsorderHandelssortimentAngivenKvantitetCommand";
    constructor(handelssortimentId: number, arbetsorderId: number, kvantitet?: number) {
        super(SetArbetsorderHandelssortimentAngivenKvantitetCommand.$type, CommandType.Replace);
        this.handelssortimentId = handelssortimentId;
        this.arbetsorderId = arbetsorderId;
        this.kvantitet = kvantitet;
    }
}
